import { Button, Input, Modal } from "antd";
import TopNav from "ui/dashboard/topnav";

import { AuthContext } from "context/AuthContext";
import { useEffect, useState, useContext, useMemo } from "react";
import { fetchSites, getOrgUser } from "lib/actions";
import { showToast } from "ui/components/common";

type OrgUserType = {
  id: string;
  email: string;
  accountName: string;
  orgId: string;
  role: string;
  token: string;
  name: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
};

type SiteManagerOrgUser = {
  user: OrgUserType;
  siteIds: number[];
};

export default function Group() {
  const { user } = useContext(AuthContext);
  const [sites, setSites] = useState([]);
  const [userList, setUserList] = useState<SiteManagerOrgUser[]>([]);
  const [isSiteLoading, setIsSiteLoading] = useState(false);
  const [isUserLoading, setIsUserLoading] = useState(false);

  useEffect(() => {
    fetchSiteData();
    fetchSiteManagers();
  }, []);

  const fetchSiteData = async () => {
    try {
      setIsUserLoading(true);
      const siteData = await fetchSites(user.token, user.orgId);
      setSites(siteData);
    } catch (error) {
      console.error("Error fetching sites:", error);
      showToast(1, "Failed to fetch Site list. Please try again later.");
    }
    setIsUserLoading(false);
  };

  const fetchSiteManagers = async () => {
    setIsSiteLoading(true);
    const role = "site_manager";
    const res = await getOrgUser(user.token, user.orgId, "", role, 0, 100);
    setIsSiteLoading(false);
    if (res.status !== 200) {
      showToast(1, "Failed to fetch org User list. Please try again later.");
      return;
    }

    const data = res?.data as {
      data: SiteManagerOrgUser[];
    };

    setUserList(data.data);
  };

  const siteUsersMap = useMemo(() => {
    const siteMap = new Map<string, OrgUserType[]>();
    if (isSiteLoading || isUserLoading) {
      return siteMap;
    }

    sites.forEach((site) => {
      const users: OrgUserType[] = [];
      userList.forEach((user) => {
        if (user.siteIds.includes(site.id)) {
          users.push(user.user);
        }
      });
      siteMap.set(site.id, users);
    });
    return siteMap;
  }, [isSiteLoading, isUserLoading]);
  console.log("siteUsersMap", siteUsersMap);

  const itemRender = (site) => {
    const users = siteUsersMap.get(site.id) || [];
    console.log("users", users);
    return (
      <div
        key={site.id}
        className="max-w-[1300px] 3xl:max-w-[1600px] flex-grow  border-t border-[#e1e1e1] text-[#222222] text-base"
      >
        <div className="flex pb-1">
          <div className="basis-[20%] 2xl:basis-[25%] 3xl:basis-[30%] flex-shrink-0 flex-grow-0 pt-7 px-3">
            <p className="font-semibold ">{site.name}</p>
            <p className="text-sm pt-3">{site?.details?.address}</p>
          </div>
          <div className="basis-[20%] flex-shrink-0 flex-grow-0 px-3">
            {users.length > 0 ? (
              users.map((user) => (
                <p className="py-6">
                  {user.firstName + " " + user.lastName || "-"}
                </p>
              ))
            ) : (
              <p className="py-6">-</p>
            )}
          </div>
          <p className="basis-[20%] flex-shrink-0 flex-grow-0 px-3">
            {users.length > 0 ? (
              users.map(() => <p className="py-6">Associate Site Manager</p>)
            ) : (
              <p className="py-6">-</p>
            )}
          </p>
          <p className="basis-[20%] flex-shrink-0 flex-grow-0 px-3">
            {users.length > 0 ? (
              users.map((e) => <p className="py-6">{e.email || "-"}</p>)
            ) : (
              <p className="py-6">-</p>
            )}
          </p>
          <p className="basis-[20%] 2xl:basis-[15%] 3xl:basis-[10%] flex-shrink-0 flex-grow-0 text-right px-3">
            {users.length > 0 ? (
              users.map((e) => (
                <p className="py-6 break-words break-all">
                  {e.phoneNumber || "-"}
                </p>
              ))
            ) : (
              <p className="py-6 ">-</p>
            )}
          </p>
        </div>
      </div>
    );
  };

  return (
    <>
      <TopNav title="Site List" />
      <div className="flex  h-full  bg-white rounded-3xl mr-6 mb-6 px-4 py-4 justify-center overflow-y-auto">
        <div className="max-w-[1300px] 3xl:max-w-[1600px] h-full flex-grow text-[#717171]">
          <div className="h-10 flex items-center  text-sm font-semibold">
            <p className="basis-[20%] 2xl:basis-[25%] 3xl:basis-[30%] flex-shrink-0 flex-grow-0 px-3">
              Site Name
            </p>
            <p className="basis-[20%] flex-shrink-0 flex-grow-0 px-3">User</p>
            <p className="basis-[20%] flex-shrink-0 flex-grow-0 px-3">Title</p>
            <p className="basis-[20%] flex-shrink-0 flex-grow-0 px-3">Email</p>
            <p className="basis-[20%] 2xl:basis-[15%] 3xl:basis-[10%] flex-shrink-0 flex-grow-0 px-3 text-right">
              Phone #
            </p>
          </div>
          {sites?.map((site) => itemRender(site))}
        </div>
      </div>
    </>
  );
}
